<template>
  <PulsBackground background-variant="3">
    <ThemeSelector />
    <NavBar
      v-if="isLoggedIn"
      current-item="help"
      :user-is-admin="userIsAdmin"
      :on-click-item="onClickNavItem"
      :auto-dark-theme="true"
      :show-logo="true"
    />
    <div class="mt-20 mb-20">
      <router-view />
    </div>
  </PulsBackground>
</template>

<script>
import Amplify from 'aws-amplify'
import { NavBar } from '@puls-solutions/pulsmeter-menu'
import {
  PulsBackground,
  ThemeSelector
} from '@puls-solutions/puls-ui-components'

export default {
  name: 'App',
  components: {
    NavBar,
    PulsBackground,
    ThemeSelector
  },
  mounted() {
    this.configureAmplify()
    if (!this.isLoggedIn) {
      this.checkAuth()
    }
    if (
      '-ms-scroll-limit' in document.documentElement.style &&
      '-ms-ime-align' in document.documentElement.style
    ) {
      // detect it's IE11
      const handleIERouting = () => {
        const currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }
      window.removeEventListener('hashchange', handleIERouting)
      window.addEventListener('hashchange', handleIERouting, false)
    }
  },
  computed: {
    isLoggedIn: function () {
      return this.loggedInUser && this.hasToken
    },
    loggedInUser: function () {
      return this.$store.getters.loggedInUser
    },
    hasToken: function () {
      return this.$store.getters.hasToken
    },
    navItems() {
      return []
    },

    userIsAdmin() {
      return this.$store.getters.isAdmin
    }
  },
  methods: {
    checkAuth: function () {
      this.$store.dispatch('checkAuthentication')
    },
    onClickNavItem(item) {
      if (item.link) {
        window.location = item.link
      } else {
        this.$router.push(item)
      }
    },
    configureAmplify() {
      if (localStorage.orgData) {
        const orgResult = JSON.parse(localStorage.orgData)
        const configObject = {
          Auth: {
            identityPoolId: orgResult.identityPoolId,
            region: 'eu-west-1',
            userPoolId: orgResult.userPoolId,
            userPoolWebClientId: orgResult.userPoolWebClientId,
            mandatorySignIn: true
          }
        }
        Amplify.configure(configObject)
      }
    }
  }
}
</script>

<style>
body {
  height: inherit !important;
  /* background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.1)),
    url('./assets/img/help.jpg');
  background-size: cover;
  background-blend-mode: darken;
  background-repeat: no-repeat;
  background-attachment: fixed; */
}
.puls-background {
  overflow: scroll;
}
</style>
